import { render } from "./MockExamPaperList.vue?vue&type=template&id=53906d4c&scoped=true&ts=true"
import script from "./MockExamPaperList.vue?vue&type=script&lang=ts"
export * from "./MockExamPaperList.vue?vue&type=script&lang=ts"

import "./MockExamPaperList.vue?vue&type=style&index=0&id=53906d4c&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/deployJob/project/music-teach/h5-internal-examination/code/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53906d4c"]])

export default __exports__